import { useQuery } from "convex/react";
import { api } from "@packages/backend/convex/_generated/api";
import { Id } from "@packages/backend/convex/_generated/dataModel";
import { msToTime } from "../lib/utilities";
import { Link, useOutletContext } from "react-router-dom";
import { PlayerContext } from "../App";
export function EpisodePlayed({
  episode_id,
  position,
}: {
  episode_id: Id<"episode">;
  position: number;
}) {
  const episode = useQuery(api.everwhz.episode, { id: episode_id });
  const { set_player_episode_id } = useOutletContext<PlayerContext>();
  if (episode === undefined)
    return <div className="episode">Loading episode…</div>;
  if (!episode) return null;
  return (
    <article className="episode">
      <div className="ep-top">
        <Link to={`/episodes/${episode.podcast_id}`}>
          {episode.podcast_title || "Podcast"}
        </Link>
      </div>
      <h2 className="ep-title">{episode.title}</h2>
      <div className="ep-bottom">
        <span className="subline">Last position: {msToTime(position)}</span>
        <button
          className="ep-link"
          disabled={!episode.mp3_link}
          onClick={() => set_player_episode_id(episode_id)}
        >
          ▶ Resume listening
        </button>
      </div>
    </article>
  );
}
export default function PlayHistory() {
  const history = useQuery(api.everwhz.getPlayStatusHistory, {});
  return (
    <main className="content-page">
      <div className="eyebrow">Your archive</div>
      <h1 className="headline">Listening history</h1>
      <p className="subline">Pick up where you left off.</p>
      <div className="episodes">
        {history === undefined ? (
          <div className="empty" role="status">
            Loading listening history…
          </div>
        ) : history.length ? (
          history.map((p) => (
            <EpisodePlayed
              key={p._id}
              episode_id={p.episode_id}
              position={p.position}
            />
          ))
        ) : (
          <div className="empty">
            Your listening history will appear here after you play an episode.
            <br />
            <Link className="ep-link" to="/">
              Explore the archive →
            </Link>
          </div>
        )}
      </div>
    </main>
  );
}
